module.exports = __webpack_public_path__ + "img/1.31d187eb.jpg";